<script>
  import { FormItem } from 'element-ui'
  export default {
    name:'ElFormItem',
    extends:FormItem
  }
</script>
